import { NgModule } from '@angular/core';
import { WidgetListComponent } from './widget-list.component';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { WidgetsModule } from '../../widgets/widgets.module';
import { SpinnerComponent } from './../../widgets/spinner/spinner.component';
import { WidgetListItemComponent } from './widget-list-item/widget-list-item.component';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
    imports: [
        WidgetsModule,
        DropDownListModule
    ],
    providers: [
        DynamicComponentService
    ],
    declarations: [
        WidgetListItemComponent,
        WidgetListComponent
    ],
    exports: [
        WidgetListComponent
    ]
})
export class WidgetListModule { }
